module.exports = __webpack_public_path__ + "static/32-Seachange-5a189c149735b5c3f7081785e92716ab.png";